import React from 'react';

export const AddToCartContext = React.createContext({
    cartList: null,
    itemCount: null,
    addToCart: null,
    removeFromCart: null,
    updateFromCart: null,
    resetCartList: null,
    cartButtonHidden: null,
    setCartButtonHidden: null,
    pricePrefix: null,
    colors: null,
    buttonFields: null
})